
import React, { useState, useRef, useEffect } from "react";
import { Modal, Form, Row, Col, Overlay, Popover, Button } from "react-bootstrap";
import ReactSelect from "react-select";
import "bootstrap/dist/css/bootstrap.min.css";
import { fetchIndustryData, setSelectedIndustry } from "../../redux/actions/industryActions";
import { useDispatch, useSelector } from "react-redux";
import { fetchSkill, selectSkill } from "../../redux/actions/skillAction";
import { customStyles } from "../../selectStyles";
import CloseSharpIcon from '@mui/icons-material/CloseSharp';
import { useParams } from "react-router-dom";
import axios from "../../API/axios";
import toast from "react-hot-toast";


const AddSkills = ({ show, handleClose, getUserCv, userDataId }) => {
    // console.log('experienceData', experienceData);
    const sessionId = localStorage.getItem("sessionId");
    const userType = localStorage.getItem("userType");
    const { CandidateId } = useParams();
    console.log("userDataId", userDataId);
    const [skillName, setSkillName] = useState([]);
    const [display, setDisplay] = useState(false)

    const [formChanged, setFormChanged] = useState(false); // Track if form is modified
    const [isSubmitting, setIsSubmitting] = useState(false);
    // Handle changes and mark form as modified
    const handleFieldChange = (setter, value , fieldName) => {
        setter(value);
        // setFormChanged(true); 
        validateForm(fieldName, value);
    };

    // Function to check if all required fields are filled
    const validateForm = (fieldName, value) => {
        const updatedIndustryId = fieldName === "industryId" ? value : industryId;
        const updatedSkillListId = fieldName === "skillListId" ? value : skillListId;
    
        if (updatedIndustryId && updatedSkillListId?.length > 0) {
            setFormChanged(true);  
        } else {
            setFormChanged(false);  
        }
    };
    
    console.log("skillName", skillName);

    const multiLang = Array.isArray(skillName)
        ? skillName.map((option) => option.label).join(",")
        : "";
    console.log("multiLang", multiLang);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsSubmitting(true); // Disable the button during submission

        const body = {
            sessionId: sessionId,
            userDataId: userDataId,
            userType: userType,
            instnCnddtID: CandidateId === 'Candidate' ? null : CandidateId,
            skillName: skillName,
            fiid: industryId,
        };

        console.log("body", body);

        try {
            const res = await axios.post("/Resume/AddSkill", body);
            console.log("res", res);
            toast.success(res.data.message);

            setSelectedSkills([]);
            setSkillListId(null);
    
            resetForm();
            setFormChanged(false); 
        } catch (error) {
            if (error.response && error.response.status === 404) {
                toast.error(error.response.data.message);
            } else {
                toast.error(error.response?.data?.message);
            }
        } finally {
            setIsSubmitting(false); // Ensure the button is re-enabled in case of failure
        }
    };

    const resetForm = () => {
        handleClose();
        getUserCv();
        setSkillName([])
        setIndustryId('')
        setSkillListId('')
        setDisplay(false)
        setFormChanged(false); // Disable the button after update
    };

    const handleCloseSkill = () => {
        resetForm(); // Call resetForm when closing the modal
        handleClose();
    };
    // ..................................................................................
    const [showTooltip, setShowTooltip] = useState(false); // Manages tooltip visibility
    const [newSkill, setNewSkill] = useState(""); // Stores new skill input
    const targetRef = useRef(null); // Ref to anchor tooltip

    // Toggle tooltip visibility
    const toggleTooltip = () => {
        console.log("Toggling Tooltip");
        setShowTooltip((prev) => !prev);
    };
    console.log(targetRef.current);
    // Save the new skill
    const handleSaveSkill = () => {
        console.log("New Skill Created:", newSkill);
        setShowTooltip(false); // Close tooltip
        setNewSkill(""); // Reset input
        // Add logic to save skill (e.g., API call or state update)
    };

    // ...............................Industry DDL.......................................
    const [displays, setDisplays] = useState(false)
    const [industryId, setIndustryId] = useState("");
    const dispatch = useDispatch();
    const { industryList, selectedIndustryId } = useSelector(
        (state) => state.industry
    );

    console.log();
    
    useEffect(() => {
        dispatch(fetchIndustryData());
    }, [dispatch]);


    const handleIndustrySelect = (val) => {
        //  dispatch(setSelectedIndustry(val.value));
        if (val) {
            setIndustryId(val.value);
        } else {
            setIndustryId(null);
        }
    };
    console.log("industryId", industryId);

    // ...............................Industry DDL.......................................

    // ...............................skill DDL.......................................
    const [skillListId, setSkillListId] = useState("");

    const { skillList, selectedSkillId } = useSelector(
        (state) => state.skill

    );
    console.log("skillList", skillList);

    const handleSkillSelect = (selectedOption) => {
        console.log("selectedOption", selectedOption);

        if (selectedOption) {
            //   dispatch(selectSkill(selectedOption.value));
            setSkillListId(selectedOption.map(option => option.value)||[])
            setSkillName(selectedOption.map(option => option.label)||[]);
        } 
        setFormChanged(true)
    };


    useEffect(() => {
        if (industryId) {
            dispatch(fetchSkill(industryId)); // Pass industryId to the action
        }
    }, [dispatch, industryId]);



    // ...............................skill DDL.......................................
    const [inputValue, setInputValue] = useState('');
    const [selectedSkills, setSelectedSkills] = useState([]);

    const handleInputChange = (inputValue, { action }) => {
        if (action === 'input-change') {
            setInputValue(inputValue);
        }
    };

    const handleChange = (selectedOptions) => {
        setSelectedSkills(selectedOptions);
        handleSkillSelect(selectedOptions); // Call your original skill select handler
    };

    const combinedOptions = [...skillList];
    if (inputValue && !skillList.find(opt => opt.label === inputValue)) {
        combinedOptions.push({ value: inputValue, label: inputValue });
    }

    return (
        <Modal show={show} onHide={handleCloseSkill} centered size="md" className="add-skills-modal">
            <Modal.Header >
                <Modal.Title>Add skills</Modal.Title>
                <CloseSharpIcon className="pointer" onClick={handleCloseSkill} />
            </Modal.Header>
            <Modal.Body className="settings">
                <Row>
                    {/* Industry Selection */}
                    {/* Industry Selection */}
                    <Col md={12}>
                        <Form.Group controlId="Industry">
                            <Form.Label className="class-type">
                                Industry <span style={{ color: "red" }}> *</span>
                            </Form.Label>
                        </Form.Group>

                        <div className="post-form-group">
                            <ReactSelect
                                options={industryList}
                                // onChange={(selectedOption) => handleFieldChange(setIndustryId, selectedOption?.value)}
                                onChange={(selectedOption) => handleFieldChange(setIndustryId, selectedOption?.value, "industryId")}
                                value={
                                    industryList.find((option) => option.value === industryId) || null
                                }
                                placeholder="Select industry"
                                classNamePrefix="react-select"
                                className="form-control"
                                styles={customStyles}
                            />
                            {display && !industryId && (
                                <span className="error_msg_lbl text-red">Please select industry first</span>
                            )}
                        </div>
                    </Col>

                
                    <Col md={12} className="mt-2">
                        <Form.Group controlId="Skills">
                            <Form.Label className="class-type">
                                Skills
                                <span style={{ color: 'red' }}> *</span>
                                {!industryId && (
                                    <span style={{ marginLeft: "3px" }} className="error_msg_lbl text-red">Please select industry first</span>
                                )}
                            </Form.Label>
                        </Form.Group>

                        <div className="post-form-group mb-0">
                            <ReactSelect
                                options={combinedOptions}
                                onInputChange={handleInputChange}
                                // onChange={handleSkillSelect}
                                onChange={(selectedOptions) => {
                                    setSelectedSkills(selectedOptions); // Update selected skills state
                                    handleSkillSelect(selectedOptions); // Update selected skills state
                                    handleFieldChange(setSkillListId, selectedOptions?.map(option => option.value), "skillListId");
                                }}
                                value={selectedSkills}
                                placeholder="Select skills"
                                classNamePrefix="react-select"
                                className="form-control"
                                styles={customStyles}
                                isMulti
                                isClearable
                                isDisabled={!industryId} // Disable skills dropdown until industry is selected
                            />
                            {display && !skillListId ? (
                                <span className="error_msg_lbl text-red">Select skill</span>
                            ) : null}
                        </div>
                    </Col>
                </Row>

                {/* Submit Button */}
                <div className="add-class-submit-button mt-4 d-flex justify-content-center">
                    <div className="khojPrimaryBtn ms-3"
                    onClick={handleSubmit}
                    style={{ cursor: formChanged ? "pointer" : "default" }}
                    >
                        <a href="#/"
                            //  className=""
                            // onClick={handleSubmit}
                            className={`btn ${!formChanged || isSubmitting ? "disabled" : "enabled"}`}
                            // disabled={!formChanged || isSubmitting}
                            style={{ pointerEvents: formChanged ? "auto" : "none", border: "none" }}
                        >

                            Submit
                        </a>
                    </div>
                </div>
            </Modal.Body>
        </Modal>
    );
};

export default AddSkills;
